export const EmailValidation = (email) => {
    if (!email) return true; // Return true if email is null, undefined, or empty

    const hasMultipleAtSymbols = (email.match(/@/g) || []).length > 1;
    const invalidCharacters = [" ", ",", "#", "(", ")"].some(char => email.includes(char));
    const atpos = email.indexOf("@");
    const dotpos = email.lastIndexOf(".");
    const isValidLength = email.length <= 100;
    const hasValidFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(email);

    if (hasMultipleAtSymbols || invalidCharacters || atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length || !isValidLength || !hasValidFormat) {
        alert('Invalid E-Mail ID! Kindly enter the correct E-mail ID.');
        return false;
    }

    return true;
};